import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ZoomIn } from 'lucide-react';
import { LUNAR } from '../constants/testIds';

// Compact card used for Upcoming Lots, Previous Results, and Home previews.
export const CatalogCard = ({ art, variant = 'upcoming', to, onImageClick }) => {
  const inner = (
    <div
      className="group bg-luxury-charcoal border border-white/5 overflow-hidden hover:border-luxury-gold/30 transition-all duration-500 flex flex-col h-full w-full"
      data-testid={LUNAR.artifactCard}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-black flex items-center justify-center p-3">
        <img
          src={art.image}
          alt={art.title}
          onClick={onImageClick ? (e) => { e.preventDefault(); e.stopPropagation(); onImageClick(art); } : undefined}
          className={`max-w-full max-h-full object-contain transition-transform duration-700 group-hover:scale-[1.02] ${onImageClick ? 'cursor-zoom-in' : ''}`}
          data-testid={onImageClick ? 'catalog-zoom-image' : undefined}
        />
        {onImageClick && (
          <button
            type="button"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); onImageClick(art); }}
            className="absolute bottom-3 right-3 bg-black/70 border border-luxury-gold/50 text-luxury-gold p-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
            aria-label="Zoom image"
            data-testid="catalog-zoom-button"
          >
            <ZoomIn size={15} />
          </button>
        )}
      </div>
      <div className="p-7 flex flex-col flex-grow">
        {variant === 'preview' && (
          <span className="text-[10px] font-sans-luxury tracking-[0.2em] text-luxury-gold uppercase font-bold mb-2">
            {art.category}{art.year ? ` • ${art.year}` : ''}
          </span>
        )}
        <h3 className="text-lg font-serif-luxury text-white mb-4 flex-grow group-hover:text-luxury-goldLight transition-colors duration-300" data-testid={LUNAR.artifactTitle}>
          {art.title}
        </h3>
        <div className="border-t border-white/5 pt-4">
          {variant === 'past' ? (
            <span className="text-base font-mono-luxury text-luxury-gold font-semibold" data-testid={LUNAR.artifactBidAmount}>{art.estimated_value}</span>
          ) : variant === 'preview' ? (
            <span className="text-[10px] font-sans-luxury uppercase tracking-[0.2em] text-luxury-goldLight font-semibold flex items-center gap-1.5">
              View Details <ArrowRight size={12} />
            </span>
          ) : (
            <span className="text-sm font-sans-luxury uppercase tracking-[0.2em] text-luxury-goldLight font-medium">Upcoming Auction</span>
          )}
        </div>
      </div>
    </div>
  );

  if (to) return <Link to={to} className="block h-full">{inner}</Link>;
  return inner;
};
